<template>
<div class="chapter">
<div class="inner_page">
<p class="txt"> </p>
<p class="txt"> </p>
<p class="txt"> </p>
<p class="copy">Publisher: Amy Marson</p>
<p class="copy">Creative Director: Gailen Runge</p>
<p class="copy">Editors: Liz Aneloski and Katie Van Amburg</p>
<p class="copy">Technical Editor: Ellen Pahl</p>
<p class="copy">Cover/Book Designer: April Mostek</p>
<p class="copy">Production Coordinator: Tim Manibusan</p>
<p class="copy">Production Editor: Jennifer Warren</p>
<p class="copy">Illustrator: Kirstie L. Pettersen</p>
<p class="copy">Photo Assistant: Mai Yong Vang</p>
<p class="copy">Hand Model: Kristi Visser</p>
<p class="copy">Style photography by Laura Webb and instructional photography by Diane Pedersen of C&amp;T Publishing, Inc., unless otherwise noted</p>
<p class="copy">Published by C&amp;T Publishing, Inc., P.O. Box 1456, Lafayette, CA 94549</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_copyright.vue?1c9e5f6d